import { AssocUtilisateurFermeService } from './assocutilisateurferme.service';
import { AssocUtilisateurFerme } from './../models/assocutilisateurferme.model';
import { FermeService } from './ferme.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { Utilisateur } from '../models/utilisateur.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { throwError } from 'rxjs';
import { Ferme } from '../models/ferme.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'access_token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UtilisateurService {

  baseUrl: string = environment.apiUrl;
  fermeId: number;
  selectedFerme: Ferme;

  constructor(private httpClient: HttpClient,
    private aufService: AssocUtilisateurFermeService,
    private fermeService: FermeService) {
  }

  get_utilisateurs() {
    return this.httpClient.get(this.baseUrl + '/utilisateur/' + this.fermeService.selectedFerme.id)
    .catch((error: any) => {
      return throwError(error);
    });
  }

  update_utilisateur(utilisateur: Utilisateur) {
    return this.httpClient.put<Utilisateur>(this.baseUrl + '/utilisateur/update/' + utilisateur.id, utilisateur, httpOptions)
    .catch((error: any) => {
      return throwError(error);
    });
  }

  delete_utilisateur(id: Number) {
    return this.httpClient.delete(this.baseUrl + '/utilisateur/delete/' + id, httpOptions)
    .catch((error: any) => {
      return throwError(error);
    });
  }

  create_utilisateur(utilisateur: Utilisateur) {
    return this.httpClient.post<Utilisateur>(this.baseUrl + '/utilisateur/create', utilisateur, httpOptions)
      .catch((error: any) => {
      return throwError(error);
      });
    }
}
